import React from 'react';
import { FaLinkedin, FaGithub, FaHandshake } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { IoDocumentText } from 'react-icons/io5';

const contactLinks = [
    { name: 'LinkedIn', Icon: FaLinkedin, href: 'https://www.linkedin.com/in/aidan-mcqueen/' },
    { name: 'GitHub', Icon: FaGithub, href: 'https://github.com/AMcQueen95' },
    { name: 'Handshake', Icon: FaHandshake, href: 'https://app.joinhandshake.com/profiles/hxb4zs' },
    { name: 'Email', Icon: MdEmail, href: 'mailto:aidanmcqueenbusiness@email.com' },
];

const resumeLink = { name: 'Resume', Icon: IoDocumentText, href: '/Resume.pdf' };

const ContactButton = ({ name, Icon, href }) => {
    const [isHovered, setIsHovered] = React.useState(false);
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{
                background: '#1C1C1E',
                color: '#E5E5EA',
                textDecoration: 'none',
                padding: '0.75rem 1.5rem',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                transition: 'transform 0.2s ease-in-out',
                transform: isHovered ? 'scale(1.05)' : 'scale(1)',
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Icon size={24} />
            <span>{name}</span>
        </a>
    );
};

const Contact = () => (
    <section id="contact" style={{
        background: '#000',
        color: '#fff',
        padding: '4rem 2rem',
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
    }}>
        <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <h2 style={{ fontSize: '2.5rem', marginBottom: '3rem', fontWeight: 'bold' }}>Contact Me</h2>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1.5rem', marginBottom: '1.5rem' }}>
                {contactLinks.map(link => <ContactButton key={link.name} {...link} />)}
            </div>
            <div>
                <ContactButton {...resumeLink} />
            </div>
        </div>
        <footer style={{ color: '#8E8E93', fontSize: '0.9rem', marginTop: 'auto', paddingTop: '2rem' }}>
            © {new Date().getFullYear()} Aidan McQueen. All rights reserved.
        </footer>
    </section>
);

export default Contact; 